import React, { useState, useEffect, useRef } from "react";

//-----------------------Reuseable-----------------------//
import Routes from "./Components/data/remote/Routes";
import "../App.css";
//-----------------------Libiraries-----------------------//
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import Modal from "react-modal";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import "jspdf-autotable";
import secureLocalStorage from "react-secure-storage";
import { Puff } from "react-loader-spinner";
import moment from "moment";
//-----------------------Images-----------------------//
import noImage from "../assets/images2/NoImage.svg";
import editImage from "../assets/images2/editColored.svg";
import editImagedisable from "../assets/images2/editDisable.svg";
import trash from "../assets/images2/trash.svg";
import Search from "../assets/images2/Search.svg";
import close from "../assets/images2/Close.svg";
import star from "../assets/images2/star.svg";
import del from "../assets/images/Delete.svg";
import delDisable from "../assets/images/trashDisable.svg";
import eye from "../assets/images/Eye.svg";
import calender from "../assets/images2/calender.svg";
import add from "../assets/images/AddColored.svg";
import addDisable from "../assets/images/addPlus.svg";
import filterSvg from "../assets/images2/filter.svg";
import pdfImr from "../assets/images2/EnablePdf.svg";
import printImr from "../assets/images2/printImr.svg";
import ok from "../assets/images/Ok.svg";
import Add from "../assets/images/AddColoredTable.svg";
import starFill from "../assets/images/StarFill.svg";
import filter from "../assets/images/filterSearch.svg";
import filter2 from "../assets/images/filterSearchPlus.svg";
import { FaSort } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import inProgress from "../assets/images/inprogress.svg";
//-----------------------Header-Footer-----------------------//
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import { BsSearch } from "react-icons/bs";
import { Tooltip } from "react-tooltip";
import ReactToPrint from "react-to-print";
import { UnAuthModal } from "../reuseable/UnAuthModal";
import { checkAuth } from "../reuseable/UnAuthFunction";

Modal.setAppElement("#root");

const customSortIcon = (sortDirection) => {
  if (sortDirection === "asc") {
    return <FaSort className="" />;
  } else if (sortDirection === "desc") {
    return <FaSort className="" />;
  } else {
    return null;
  }
};
const Imr = (props) => {
  const columns = [
    {
      id: 1,
      name: "Material Code",
      selector: (row) => row?.material_code,
      sortable: true,
    },
    {
      id: 2,
      name: "Material Category",
      selector: (row) => row?.material_category,
      sortable: true,
    },
    {
      id: 3,
      name: "Class",
      selector: (row) => row?.class,
      sortable: true,
    },
    {
      id: 4,
      name: "Short Text",
      selector: (row) => row?.short_text,
      sortable: true,
    },
    {
      id: 5,
      name: "Long Text",
      selector: (row) => row?.long_text,
      sortable: true,
    },
    {
      id: 6,
      name: "UoM",
      selector: (row) => row?.UOM,
      sortable: true,
    },
    {
      id: 7,
      name: "Manufacturer",
      selector: (row) => row?.manufacturer,
      sortable: true,
    },
    {
      id: 8,
      name: "Manufacturing Model",
      selector: (row) => row?.manufacturer_model,
      sortable: true,
    },

    {
      id: 9,
      name: "Select Items",
      cell: (row) => (
        <>
          {data4?.some((item) => item.id === row.id) ? (
            <img
              style={{ cursor: "pointer" }}
              onClick={() => handleToggle(row)}
              src={ok}
              alt="ok"
            />
          ) : (
            <img
              style={{ cursor: "pointer" }}
              className="my-element"
              data-tooltip-content="Add Request"
              onClick={() => handleToggle(row)}
              src={Add}
              alt="Add"
            />
          )}
        </>
      ),
    },
  ];

  //states
  const [showTable, setShowTable] = useState(false);
  const [showTableTwo, setShowTableTwo] = useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editedRow, setEditedRow] = useState(null);
  const [fileInputs, setFileInputs] = useState([{ id: 0, file: null }]);
  const [imrDataTable, setImrTableData] = useState([]);
  const [saveImr, setSaveImr] = useState(false);
  const [releaseImr, setReleaseImr] = useState(false);
  const [createPr, setCreatePr] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState();

  const [CurrentData, setCurrntDate] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption3, setSelectedOption3] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [filteredData2, setFilteredData2] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);
  const datePickerRef = useRef(null);
  const [boleanVal, setBolean] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [file, setFile] = useState([]);
  const [showFullText, setShowFullText] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(5);
  const [page3, setPage3] = useState(0);
  const [perPage3, setPerPage3] = useState(25);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchMaterial, setSearchMaterial] = useState([]);
  const [filterCountries, setFilterCountries] = useState([]);
  const [filterCountries2, setFilterCountries2] = useState([]);

  const [data4, setdata4] = useState([]);
  const [disableEditButton, setDisableEditButton] = useState(true);
  const [editApiEnable, setEditApiEnable] = useState(false);
  const [projectId, setProjectId] = useState();
  const [level, setLevel] = useState(0);
  const [search, setSearch] = useState("");
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [selectedOptions2, setSelectedOptions2] = useState([]); // Update state to an array to store multiple selected options
  const [materialId, setMaterialId] = useState("");
  const [firstName, setFirstName] = useState(
    secureLocalStorage.getItem("first_name")
  );
  const [lastName, setLastName] = useState(
    secureLocalStorage.getItem("last_name")
  );
  const [requiredDeliveryDate, setRequiredDeliveryDate] = useState([]);
  // api section
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedImageArray, setSelectedImageArray] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [ceateprojectId, setCreateProjectId] = useState("");
  const [imrNumber, setImrNo] = useState("");
  const [currentLevel, setCurrentLevel] = useState("");
  const [totalLevel, setTotalLevel] = useState("");
  const [requestId, setRequestId] = useState("");
  const [status, setStatus] = useState("");
  const [imrDate, setImrDate] = useState("");
  const [imrTime, setImrTime] = useState("");

  const [userComment, setUserComment] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [releaseArray, setReleaseArray] = useState([]);
  const [posts, setPosts] = useState("");
  const [showInputFields, setShowInputFields] = useState(false);
  const [createIMRRequest, setCreateImr] = useState();
  const [textAreaValue, setTextAreaValue] = useState("");
  const [editedNames, setEditedNames] = useState({}); // new state object to hold the edited name value for each row
  const [editedAges, setEditedAges] = useState({}); // new state object to hold the edited age value for each row
  const [editedEmails, setEditedEmails] = useState({}); // new state object to hold the edited email value for each row
  const [editedDobs, setEditedDobs] = useState({}); // new state object to hold the edited dob value for each row
  const [names, setNames] = useState(data4.map((row) => row.name));
  const [dobs, setDobs] = useState(data4.map((row) => row.dob));
  const [emails, setEmails] = useState(data4.map((row) => row.email));
  const [stockLoation, setStokeLocation] = useState(
    data4.map((row) => row?.stock[0]?.location)
  );
  const [stockQty, setStockQty] = useState(
    data4.map((row) => row?.stock[0]?.quantity)
  );
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [selectedMaterialCode, setSelectedMaterialCode] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedShortText, setSelectedShortText] = useState(null);
  const datepickerRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [numSelectedOptions2, setNumSelectedOptions2] = useState(0);
  const inputRefImage = useRef(null);
  const [modalIsOpen, setIsOpen4] = useState(false);
  const [modalIsOpen5, setIsOpen5] = useState(false);
  const [deleteFile, setDeleteFile] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");
  const [filterProjects, setfilterProjects] = useState([]);
  const [selectedValue2, setSelectedValue] = useState([]);
  const componentRef = useRef();
  const navigate = useNavigate();
  let subtitle;

  useEffect(() => {
    setNames(data4.map((row) => row.quantity));
    setDobs(data4.map((row) => row.dobs));
    setEmails(data4.map((row) => row.WBSElement));
    setStokeLocation(
      data4.map((row) =>
        row?.stock.map((item) => {
          return item?.location;
        })
      )
    );

    setStockQty(
      data4.map((row) =>
        row?.stock.map((item) => {
          return item?.quantity;
        })
      )
    );
  }, [data4]);
  //section end
  const dropdownRef = useRef(null);

  const handlerun = (e) => {
    setfilterProjects(
      projects?.projects?.filter((option) =>
        option.project_name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
    setProjectSearch(e.target.value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        handleSave();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [datePickerRef]);

  const columns2 = [
    {
      id: 1,
      name: "Item no",
      selector: (row, index) => page3 * perPage3 + index + 1,
      sortable: true,
    },
    {
      id: 2,
      name: "Material Type",
      selector: (row) => row?.material_type,
      sortable: true,
    },
    {
      id: 3,
      name: "Material Category",
      selector: (row) => row?.material_category,
      sortable: true,
    },
    {
      id: 4,
      name: "Material Code",
      selector: (row) => row?.material_code,
      sortable: true,
    },
    {
      id: 5,
      name: "Short Text",
      selector: (row) => row?.short_text,
      sortable: true,
    },
    {
      id: 6,
      name: "Long Text",
      selector: (row) => row?.long_text,
      sortable: true,
    },
    {
      id: 7,
      // name: "Quantity",
      name: (
        <div className="tableHeaders">
          <span className="quantitySpan" style={{ color: "red" }}>
            *
          </span>{" "}
          Quantity
        </div>
      ),
      selector: (row) => row?.quantity,
      sortable: true,
      cell: (row) => {
        const editedValue = editedValues[row.id]?.quantity;
        if (!row.quantity && editingRow !== row.id) {
          return (
            <div
              className="placeholderText"
              onClick={() => setEditingRow(row.id)}
            >
              Enter quantity
            </div>
          );
        }

        return (
          <div onClick={() => setEditingRow(row.id)}>
            {editingRow === row.id ? (
              <input
                type="number"
                value={editedValue || row.quantity}
                placeholder="Enter quantity"
                className="onFocusInput"
                onClick={(e) => e.stopPropagation()} // prevent event propagation
                onChange={(e) => {
                  const newValue = parseInt(e.target.value);
                  if (newValue >= 0) {
                    setEditedValues({
                      ...editedValues,
                      [row.id]: {
                        ...editedValues[row.id],
                        quantity: newValue,
                      },
                    });
                  }
                }}
                onBlur={handleSave}
                min={0} // set the minimum value to 0
              />
            ) : (
              editedValue || row.quantity
            )}
          </div>
        );
      },
    },
    {
      id: 8,
      name: "Unit",
      selector: (row) => row?.unit,
      sortable: true,
    },

    {
      id: 9,
      name: (
        <div className="tableHeaders">
          <span className="quantitySpan" style={{ color: "red" }}>
            *
          </span>{" "}
          Required delivery date
        </div>
      ),
      selector: (row) => row?.dobs,
      sortable: true,
      cell: (row) => {
        const editedValue = editedValues[row.id]?.dobs;
        const currentValue = editedValues[row.id]?.dobs || row.dobs;

        const handleChange = (event, row) => {
          const { value } = event.target;
          setEditedValues({
            ...editedValues,
            [row.id]: {
              ...editedValues[row.id],
              dobs: value,
            },
          });
        };
        const handleBlur = (row) => {
          const editedValue = editedValues[row.id]?.dobs;
          const currentValue = editedValues[row.id]?.dobs || row.dobs;
          if (
            currentValue !== row.dobs ||
            currentValue === "" ||
            currentValue === undefined
          ) {
            handleSave();
          }
        };
        const handleInputClick = (event) => {
          event.stopPropagation();
          datepickerRef.current.setOpen(true);
        };

        const handleDateChange = (e) => {
          if (e == null) {
            row.dobs = null;
          }
        };
        const handleSelect = (date, row) => {
          setEditedValues({
            ...editedValues,
            [row.id]: {
              ...editedValues[row.id],
              dobs: moment(date).format("YYYY-MM-DD"),
            },
          });
          setSelectedDate(moment(date).toDate()); // Update selected date
          datepickerRef.current.setOpen(false);
          setTimeout(() => {
            datepickerRef.current.input.focus();
          }, 0);
        };
        if (!row.dobs && editingRow !== row.id) {
          return (
            <div
              className="placeholderText"
              onClick={() => setEditingRow(row.id)}
            >
              Select Date
            </div>
          );
        }

        return (
          <div
            className="position-relative"
            onClick={() => setEditingRow(row.id)}
          >
            {editingRow === row.id ? (
              <div>
                {/* {console.log("editedValue====>", editedValue, row.dobs)} */}
                {/* <input
                  type="text"
                  value={editedValue ? moment(editedValue, 'YYYY-MM-DD').toDate() : null}
                  onChange={handleChange}
                  onClick={handleInputClick}

                /> */}
                <DatePicker
                  placeholder="Enter Date"
                  className="onFocusInput"
                  placeholderText="Select Date"
                  selected={
                    editedValue
                      ? moment(editedValue, "YYYY-MM-DD").toDate()
                      : row.dobs
                      ? moment(row.dobs, "YYYY-MM-DD").toDate()
                      : null
                  } // Use editedValue or row.dobs as selected date
                  dateFormat="dd-MM-yyyy"
                  onChange={(e) => handleDateChange(e)}
                  onSelect={(date) => handleSelect(date, row)}
                  onBlur={() => handleBlur(row)}
                  ref={datepickerRef}
                  onClick={(e) => e.stopPropagation()} // prevent event propagation
                  minDate={moment().add(7, "days").toDate()}
                />
              </div>
            ) : (
              editedValue || moment(row.dobs).format("DD-MM-YYYY")
            )}
          </div>
        );
      },
    },

    {
      id: 10,
      name: "Manufacturer",
      selector: (row) => row?.manufacturer,
      sortable: true,
    },
    {
      id: 11,
      name: "Manufacturing Model",
      selector: (row) => row?.manufacturer_model,
      sortable: true,
    },
    {
      id: 12,
      name: (
        <div className="tableHeaders">
          <span className="quantitySpan" style={{ color: "red" }}>
            *
          </span>{" "}
          WBS Element
        </div>
      ),
      // selector: "WBSElement",
      selector: (row) => row?.WBSElement,

      sortable: true,
      cell: (row) => {
        const editedValue = editedValues[row.id]?.WBSElement;
        if (!row.WBSElement && editingRow !== row.id) {
          return (
            <div
              className="placeholderText"
              onClick={() => setEditingRow(row.id)}
            >
              Enter WBS Element
            </div>
          );
        }
        return (
          <div onClick={() => setEditingRow(row.id)}>
            {editingRow === row.id ? (
              <input
                type="text"
                className="onFocusInput"
                placeholder="Enter WBS Element"
                value={editedValue || row.WBSElement}
                onClick={(e) => e.stopPropagation()} // prevent event propagation
                onChange={(e) =>
                  setEditedValues({
                    ...editedValues,
                    [row.id]: {
                      ...editedValues[row.id],
                      WBSElement: e.target.value,
                    },
                  })
                }
                onBlur={handleSave}
              />
            ) : (
              editedValue || row.WBSElement
            )}
          </div>
        );
      },
    },

    {
      id: 13,
      name: "Plant",
      selector: (row) => row?.plant,
      sortable: true,
    },
    {
      id: 14,
      name: "Stock Available Location",
      selector: (row) => (
        <div className="showTwoText list-item">
          <img
            style={{
              display: "block",
              margin: "auto",
              cursor: "pointer",
              width: 25,
              height: "auto",
              textTransform: "capitalize",
            }}
            data-tooltip-content="This Feature Will Be Implemented In Next Iteraion"
            className=" my-element"
            src={inProgress}
            alt="inProgress"
          />
        </div>
      ),
      sortable: true,
    },
    {
      id: 15,
      name: "Stock Available Qty",
      selector: (row) => (
        <div className="showTwoText list-item">
          <img
            style={{
              display: "block",
              margin: "auto",
              cursor: "pointer",
              width: 25,
              height: "auto",
              textTransform: "capitalize",
            }}
            data-tooltip-content="This Feature Will Be Implemented In Next Iteraion"
            className=" my-element"
            src={inProgress}
            alt="inProgress"
          />
        </div>
      ),
      sortable: true,
    },

    {
      id: 16,
      name: "Quick Actions",
      button: true,
      cell: (row, index) => {
        if (editingRow === row.id) {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{ cursor: "pointer", fontSize: "25px" }}
                onClick={() => {
                  const index = data4.findIndex((r) => r.id === row.id);
                  const newData = [...data4];
                  newData[index] = { ...newData[index], ...editedValues };
                  // if (!editedValues.quantity) {
                  //   return notify('quantity is a required field', 'error');
                  // } else if (!editedValues.dobs) {
                  //   return notify('RequiredDelveryDate is a required field', 'error');
                  // } else if (!editedValues.WBSElement) {
                  //   return notify('Wbs element is a required field', 'error');
                  // }
                  // else {
                  setdata4(newData);
                  setEditingRow(null);
                  setEditedValues({});
                  setEditedNames({
                    ...editedNames,
                    [row.id]: undefined, // reset the edited name value for the row
                  });
                  setEditedAges({
                    ...editedAges,
                    [row.id]: undefined, // reset the edited age value for the row
                  });
                  setEditedEmails({
                    ...editedEmails,
                    [row.id]: undefined, // reset the edited email value for the row
                  });
                  setEditedDobs({
                    ...editedDobs,
                    [row.id]: undefined, // reset the edited dob value for the row
                  });
                  // }
                }}
              >
                {/* <BiSave /> */}
              </div>
              <div
                style={{
                  fontSize: "23px",
                  marginLeft: "5px",
                  cursor: "pointer",
                }}
                onClick={() => setEditingRow(null)}
              >
                <ImCancelCircle />
              </div>
            </div>
          );
        }
        return (
          <div className="d-flex align-items-center justify-content-center">
            <div>
              {isSaveEnabled ? (
                <img
                  className="editImageIcon"
                  onClick={() => {
                    setEditingRow(row.id);
                    setEditApiEnable(true);
                  }}
                  src={editImage}
                  alt="editImage"
                />
              ) : (
                <img
                  style={{ width: "25px" }}
                  src={editImagedisable}
                  alt="editImagedisable"
                  className="editImageIcon my-element"
                  data-tooltip-content="Edit Request"
                />
              )}
            </div>
            <img
              onClick={() => {
                openModal5();
                setDeleteRowId(row?.id);
              }}
              className="editImageIcon my-element"
              data-tooltip-content="Delete Request"
              src={trash}
              alt="trash"
            />
            {modalIsOpen5 ? (
              <div className="deleteAccountMain">
                <Modal
                  isOpen={modalIsOpen5}
                  onAfterOpen={afterOpenModal5}
                  onRequestClose={closeModal5}
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <div className="delModelHeader">
                    <h2>Delete Confirmation</h2>
                    <div class="horizontal-line"></div>
                    <p>Are you sure you want to delete this material?</p>
                    <div className="modal-button">
                      <button
                        onClick={() => handleDelete(row, index)}
                        className="delAccountOkButton d-flex align-items-center justify-content-center"
                      >
                        Ok
                      </button>
                      <button
                        onClick={closeModal5}
                        className="delAccountCancelButton d-flex align-items-center justify-content-center"
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </Modal>
              </div>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
  ];
  const handleSort = (column, sortDirection) => {
    setSortColumn(column.selector);
    setSortDirection(sortDirection);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "15px",
    },
  };

  function openModal() {
    if (selectedRows?.length === 0) {
      return notify("Please select one or more rows to delete", "error");
    } else {
      setIsOpen4(true);
    }
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }
  function closeModal() {
    setIsOpen4(false);
  }

  function openModal5() {
    setIsOpen5(true);
  }
  function afterOpenModal5() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }
  function closeModal5() {
    setIsOpen5(false);
  }
  const handleMaterialCodeAccordionItemClick = (item) => {
    setSelectedMaterialCode(item);
    setSelectedClass("");
    setSelectedShortText("");
  };

  const handleClassAccordionItemClick = (item) => {
    setSelectedClass(item);
    setSelectedMaterialCode("");
    setSelectedShortText("");
  };

  const handleShortTextAccordionItemClick = (item) => {
    setSelectedShortText(item);
    setSelectedMaterialCode("");
    setSelectedClass("");
  };
  const handleIconClick = () => {
    setIsOpen2(!isOpen2);
  };

  useEffect(() => {
    checkAuth();

    const handleBackButton = (event) => {
      event.preventDefault();
      setEditedValues({});
      setEditingRow(null);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  useEffect(() => {
    validate();
  }, [editedValues]);

  const validate = () => {
    const errors = {};
    let hasErrors = false; // Initialize hasErrors variable

    data4.forEach((row) => {
      // Check if Quantity field is empty
      if (!row.quantity) {
        errors[row.id] = {
          ...errors[row.id],
          quantity: "Required field",
        };
      }
      // Check if Required delivery date field is empty
      if (!row.dobs) {
        errors[row.id] = {
          ...errors[row.id],
          dobs: "Required field",
        };
      }
      // Check if WBS Element field is empty
      if (!row.WBSElement) {
        errors[row.id] = {
          ...errors[row.id],
          WBSElement: "Required field",
        };
      }
    });

    hasErrors = Object.keys(errors).length > 0; // Check if there are any errors
    // Check if all required fields are filled in and there are no errors
    const allFieldsFilled = data4.every(
      (row) => row.quantity && row.dobs && row.WBSElement
    );
    setIsSaveEnabled(!hasErrors && allFieldsFilled); // Enable/disable save button

    return errors;
  };

  const history = useNavigate();
  const accessToken = secureLocalStorage.getItem("token");

  const FetchProjects = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(Routes.PROJECTS, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setProjects(result?.data[0]);
        setfilterProjects(result?.data[0]?.projects);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  const FetchMaterialSearch = (keyword) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);
    var formdata = new FormData();
    formdata.append("keyword", keyword);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    return fetch(Routes.MaterialSearch, requestOptions)
      .then((response) => response.json())
      .then((result) => result?.data)
      .catch((error) => console.log("error", error));
  };

  const dropdownRef2 = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        // Clicked outside of the dropdown, close it
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleInputChange = async (event) => {
    // if (!projectId) {
    //   setLoading(false);
    //   return notify("Please select the project first");
    // }
    // setShowTable(false);
    const inputValue = event.target.value;
    setInputValue(inputValue);
    setPage(0);

    const searchResult = await FetchMaterialSearch(inputValue);
    setSearchMaterial(searchResult);
    // filter the data based on user input
    const filteredData2 = searchResult.filter((item) => {
      const matchesMaterial = item.material_code
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      const matchesMaterialDesc = item.long_text
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      const matchesLanguage = item.material_category
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      return matchesMaterial || matchesMaterialDesc || matchesLanguage;
    });

    setFilteredData2(filteredData2);

    setIsOpen(inputValue !== "");
  };

  useEffect(() => {
    if (!search) {
      setFilterCountries(filterCountries2);
    } else {
      const result = filterCountries.filter(
        (item) =>
          JSON.stringify(item).toLowerCase().includes(search.toLowerCase()),
        setPage(0)
      );
      setFilterCountries(result);
    }
  }, [search]);

  const ReleaseButtonMethod = (level) => {
    const buttons = [];
    for (let index = 0; index < level; index++) {
      if (saveImr && !createIMRRequest?.status && !releaseImr && !createPr) {
        if (index === parseInt(currentLevel) - 1) {
          // subtract 1 to match array index
          buttons.push(
            <button
              onClick={() => releaseImrMethod()}
              className="releaseISR-btn"
            >
              Release {index + 1}
            </button>
          );
        } else {
          buttons.push(
            <button disabled className="releaseDisableISR-btn">
              Release {index + 1}
            </button>
          );
        }
      } else {
        buttons.push(
          <button
            disabled
            onClick={() => releaseImrMethod()}
            className="releaseDisableISR-btn"
          >
            Release {index + 1}
          </button>
        );
      }
    }

    return buttons;
  };

  useEffect(() => {
    if (!accessToken) {
      history("/");
    } else {
      FetchProjects();
    }
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  const handleChangeRowsPerPage = (event) => {
    setPerPage3(Number(event.target.value));
    setPage3(0); // Reset to first page
  };

  const handleToggle = (row) => {
    const foundRow = data4.find((item) => item.id === row.id);

    if (foundRow) {
      setdata4(data4.filter((item) => item.id !== row.id)); // remove selected row from data4
      setMaterialId(materialId.filter((id) => id !== row.id));
    } else {
      setdata4([...data4, row]); // add selected row to data4
      setMaterialId((prevMaterialId) => {
        const index = prevMaterialId.indexOf(row?.id);
        if (index !== -1) {
          // Replace the previous value with the new one
          prevMaterialId.splice(index, 1, row?.id);
          return prevMaterialId;
        } else {
          // Add the new value to the array
          return [...prevMaterialId, row?.id];
        }
      });
    }
    const img = document.getElementById(`toggle-img-${row.id}`);
    if (foundRow) {
      img.src = Add; // Set the image source to the plus image
      img.alt = "Add"; // Set the alt text to "Add"
    } else {
      img.src = ok; // Set the image source to the checkmark image
      img.alt = "ok"; // Set the alt text to "ok"
    }
  };

  //funtions
  function handlePreviewClick(file) {
    if (selectedFiles && Array.isArray(selectedFiles)) {
      setSelectedFiles([...selectedFiles, file]);
    } else {
      setSelectedFiles([file]);
    }
    setShowModal(true);
  }

  function handleRemove(file) {
    inputRefImage.current.value = "";
    fileInputs[0].file = null;
    fileInputs[0].preview = null;
    fileInputs[0].fileName = null;
    if (fileInputs.length == 1) {
      selectedImageArray.shift();
    } else {
      selectedImageArray[0].file = null;
    }

    setFile("");
  }
  const handlePost = () => {
    // if (textAreaValue) { // check if there's a value in the text area
    setPosts(textAreaValue);
    // setTextAreaValue(''); // clear the text area
    // }
  };
  const handleInput = (event) => {
    const words = event.target.value.split(" ");
    const count = words.length;
    setWordCount(count);
    setTextAreaValue(event.target.value); // save the value of the text area in state
  };

  const handleReadMoreClick = () => {
    setShowFullText(!showFullText);
  };

  const notify = (message, type) => {
    type == "success"
      ? toast.success(message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        })
      : toast.error(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
  };

  // Delete by icon click iside the table method
  const handleDelete = (row) => {
    const filteredData = data4.filter((d) => d.id !== deleteRowId);

    const index = data4.findIndex((d) => d.id === deleteRowId);
    const updatedMaterialId = [
      ...materialId.slice(0, index),
      ...materialId.slice(index + 1),
    ];
    const updatedNames = [...names.slice(0, index), ...names.slice(index + 1)];
    const updatedEmails = [
      ...emails.slice(0, index),
      ...emails.slice(index + 1),
    ];
    const updatedDobs = [...dobs.slice(0, index), ...dobs.slice(index + 1)];
    setdata4(filteredData);
    setMaterialId(updatedMaterialId);
    setNames(updatedNames);
    setEmails(updatedEmails);
    setDobs(updatedDobs);
    setIsOpen5(false);
    notify("Successfully deleted!", "success");
  };

  // selected rows Delete method
  const handleDelete2 = () => {
    if (selectedRows?.length === 0) {
      return notify("Please select one or more rows to delete", "error");
    }

    const idsToDelete = selectedRows?.map((row) => row.id);
    const newData = data4?.filter((row) => !idsToDelete.includes(row.id));
    const newMaterialIds = materialId.filter((id) => !idsToDelete.includes(id));
    const newNames = names.filter(
      (_, index) => !idsToDelete.includes(data4[index]?.material?.id)
    );
    const newEmails = emails.filter(
      (_, index) => !idsToDelete.includes(data4[index]?.material?.id)
    );
    const newDobs = dobs.filter(
      (_, index) => !idsToDelete.includes(data4[index]?.material?.id)
    );

    setSelectedRows([]);
    setdata4(newData);
    setMaterialId(newMaterialIds);
    setNames(newNames);
    setEmails(newEmails);
    setDobs(
      newDobs.map((date, index) =>
        idsToDelete.includes(data4[index]?.material?.id) ? "" : date
      )
    );
    setEditApiEnable(false);
    setIsOpen4(false);
    notify("Successfully deleted!", "success");
  };

  const handleDropdownClick = (item) => {
    const searchItem = secureLocalStorage.getItem("search");
    FetchMaterialSearch(searchItem);
    const isDuplicate = filterCountries.some(
      (existingItem) => existingItem.id === item.id
    );

    if (!isDuplicate) {
      // console.log("inside method");
      setFilterCountries([...filterCountries, item]);
      setFilterCountries2([...filterCountries2, item]);
    } else {
      notify("Material already added");
    }
    setIsOpen(false);
    setShowTable(true);
    setSelectedOption2("");
    setIsOpen2(false);
    inputRef.current.blur();

    // Check if selectedOption2 is empty, use a default value
    const selectedOption = selectedOption2 || "Material Description";

    // Perform desired functionality based on selectedOption
    if (selectedOption === "") {
      // Handle case where no option is selected
    } else if (selectedOption === "Material Description") {
      // Handle Material Description functionality
      if (item.long_text) {
      }
    } else if (selectedOption === "Category") {
      // Handle Category functionality
      if (item.material_category) {
      }
    } else if (selectedOption === "Material Code") {
      // Handle Material functionality
      if (item.material_code) {
      }
    }
  };

  // Send request Api

  const saveImrMethod = () => {
    if (!textAreaValue) {
      notify("Comment is required");
      return;
    }
    setLoading(true);
    const newData = data4.map((row) => {
      if (row.id === editingRow) {
        return {
          ...row,
          ...editedValues[row.id],
        };
      }
      return row;
    });
    setdata4(newData);
    setShowInputFields(false);
    setEditedValues({});
    setEditingRow(null);
    if (!projectId) {
      setLoading(false);
      return notify("Please select the project");
    } else if (!emails.length || !names.length || !dobs.length) {
      return notify("please fill the required fields", "error");
    } else {
      // const materialIdStrings = materialId.map(id => id.toString());
      const fileCheck = fileInputs[0].file;
      if (fileCheck) {
        const check = fileInputs.some((input) => !input.file);
        if (check) {
          setLoading(false);
          return notify(`File fields can't be empty`, "error");
        }
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + accessToken);
      myHeaders.append("Accept", "application/json");

      const convertedDates = dobs.map((date) =>
        moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
      );

      var formdata = new FormData();
      formdata.append("project_id", projectId);

      materialId?.forEach((id) => {
        formdata.append("material_id[]", id);
      });
      names?.forEach((n) => {
        // console.log(n);

        formdata.append("quantity[]", n);
      });
      dobs?.forEach((date) => {
        formdata.append("delivary_date[]", date);
      });
      emails?.forEach((e) => {
        formdata.append("wbs_element[]", e);
      });
      // formdata.append("stock_location[]", "dumpyard");
      // formdata.append("stock_location[]", "dumpyard2");
      // formdata.append("stock_location[]", "dumpyard3");

      // formdata.append("stock_quantity[]", "21");
      // formdata.append("stock_quantity[]", "22");
      // formdata.append("stock_quantity[]", "23");

      stockLoation?.forEach((e) => {
        // console.log("stock_location", e);
        formdata.append("stock_location[]", e);
      });
      stockQty?.forEach((e) => {
        // console.log("stock_quantity", e);
        formdata.append("stock_quantity[]", e);
      });

      if (selectedImageArray) {
        selectedImageArray?.forEach((e) => {
          formdata.append("files[]", e.file);
        });
      }
      formdata.append("comment", textAreaValue);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        "https://alhikmahinternational.org/al-asab/public/api/create/IMR",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          // console.log("result-=-=-=->", result);

          setCreateImr(result);
          if (result.success == true) {
            setTextAreaValue("");
            setLoading(false);
            setSaveImr(true);
            notify(
              `The IMR, ${result?.data?.request_number} has been saved successfully`,
              "success"
            );
            setImrNo(result?.data?.request_prefix);
            setCreateProjectId(result?.data.project_id);
            setCurrentLevel(result?.data.current_level);
            setUserFirstName(result?.data?.created_by?.first_name);
            setUserLastName(result?.data?.created_by?.last_name);
            setUserComment(result?.data?.comments[0]?.comment);
            setTotalLevel(result.data.projects?.no_of_approval_level);
            setRequestId(result.data.id);
            setStatus(result?.data?.stage);
            secureLocalStorage.setItem("request-id", result.data.id);
            secureLocalStorage.setItem(
              "userProjectLevel",
              result?.data?.projects?.approver
            );

            // setImrDate(moment(result?.data?.created_at).format('DD-MM-YYYY'))
            const originalDate = result?.data?.created_at;
            const formattedDate = moment(originalDate).format("DD-MM-YYYY");
            const formattedTime = moment(originalDate).format("HH:mm:ss");
            setImrDate(formattedDate);
            setImrTime(formattedTime);

            navigate("/view-imr", {
              state: { myBooleanValue: 1, data: result?.data },
            });
          } else {
            setLoading(false);
            notify("Something went wrong!", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  };

  // update Request API
  const EditableTableData = () => {
    if (!textAreaValue) {
      notify("Comment is required");
      return;
    }
    setLoading(true);
    const newData = data4.map((row) => {
      if (row.id === editingRow) {
        return {
          ...row,
          ...editedValues[row.id],
        };
      }
      return row;
    });
    setdata4(newData);
    setShowInputFields(false);
    setEditedValues({});
    setEditingRow(null);
    if (!projectId) {
      return notify("Please select the project");
    } else if (!emails.length || !names.length || !dobs.length) {
      return notify("please fill the required fields", "error");
    } else {
      const fileCheck = fileInputs[0].file;
      if (fileCheck) {
        const hasNullFile = fileInputs.some(
          (obj) => obj.file === null || obj.file === undefined
        );

        if (hasNullFile) {
          setLoading(false);

          return notify("please fill the required fields", "error");
        }
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + accessToken);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();
      formdata.append("request_id", requestId);
      materialId?.forEach((id) => {
        formdata.append("material_id[]", id);
      });
      names?.forEach((n) => {
        formdata.append("quantity[]", n);
      });
      dobs?.forEach((date) => {
        formdata.append("delivary_date[]", date);
      });
      emails?.forEach((e) => {
        formdata.append("wbs_element[]", e);
      });
      stockLoation?.forEach((e) => {
        formdata.append("stock_location[]", e);
      });
      stockQty?.forEach((e) => {
        formdata.append("stock_quantity[]", e);
      });
      if (selectedImageArray) {
        selectedImageArray?.forEach((e) => {
          formdata.append("files[]", e.file);
        });
      }
      formdata.append("comment", posts);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      fetch(Routes.EditDataImr, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setCreateImr(result);
          if (result.success == true) {
            setLoading(false);
            setSaveImr(true);
            notify(
              `The IMR, ${result?.data?.request_number} has been updated successfully`,
              "success"
            );
            setImrNo(result?.data?.request_prefix);
            // setUserComment(result?.comments[0]?.comment)
            setCreateProjectId(result.data.project_id);
            setCurrentLevel(result.data.current_level);
            setUserFirstName(result?.data?.created_by?.first_name);
            setUserLastName(result?.data?.created_by?.last_name);
            setUserComment(result?.data?.comments[0]?.comment);
            setTotalLevel(result.data.projects?.no_of_approval_level);
            setRequestId(result.data.id);
            setStatus(result?.data?.stage);
            // setImrDate(moment(result?.data?.created_at).format('DD-MM-YYYY'))
            const originalDate = result?.data?.created_at;
            const formattedDate = moment(originalDate).format("DD-MM-YYYY");
            setImrDate(formattedDate);
          } else {
            setLoading(false);
            // console.log(result?.message);
            notify("Something went wrong!", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  };

  // Release request API
  const releaseImrMethod = () => {
    window.scrollTo(0, 0);
    releaseArray.push(1);
    setReleaseImr(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);
    var formdata = new FormData();
    formdata.append("project_id", ceateprojectId);
    formdata.append("current_level", currentLevel);
    formdata.append("total_level", totalLevel);
    formdata.append("request id", requestId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    fetch(Routes.ReleaseRequest, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          setDisableEditButton(false);
          notify(result.message, "success");
        } else {
        }
      })
      .catch((error) => console.log("error", error));
  };

  const [selectedOption2, setSelectedOption2] = useState("");

  const handleOptionClick = (option) => {
    if (selectedOptions2.includes(option)) {
      // If option is already selected, remove it from selectedOptions2 array
      setSelectedOptions2(
        selectedOptions2.filter((selectedOption) => selectedOption !== option)
      );
    } else {
      // If option is not selected, add it to selectedOptions2 array
      setSelectedOptions2([...selectedOptions2, option]);
    }

    if (!selectedOptions2.includes(option)) {
      setSelectedOptions2([...selectedOptions2, option]);
      setNumSelectedOptions2(numSelectedOptions2 + 1);
    }
  };
  let selectedIcons = null;
  if (selectedOptions2.length > 0) {
    selectedIcons = selectedOptions2.map((option, index) => (
      <img key={index} src={filter} alt="filter" />
    ));
  }
  // Seatch filter
  const FilterMethod = () => {
    const filteredList = filteredData2.filter((item) => {
      if (selectedOptions2.length === 0) {
        return true; // If no options are selected, return all items
      } else {
        // Check if any of the selected options match the current item's property
        return selectedOptions2.some((option) => {
          if (option === "Material Description") {
            return item.long_text
              .toLowerCase()
              .includes(inputValue.toLowerCase());
          } else if (option === "Category") {
            return item.material_category
              .toLowerCase()
              .includes(inputValue.toLowerCase());
          } else if (option === "Material") {
            return item.material_code
              .toLowerCase()
              .includes(inputValue.toLowerCase());
          }
          return false;
        });
      }
    });
    return filteredList;
  };

  useEffect(() => {
    validate();
  }, [data4, editedValues]);
  const handleSave = () => {
    // Update table data with edited values
    const newData = data4.map((row) => {
      if (row.id === editingRow) {
        return Object.assign({}, row, editedValues[row.id]);
      }
      return row;
    });
    setdata4(newData);

    // Hide input fields and clear edited values
    setEditedValues({});
    setEditingRow(null);

    // Check if save button should be enabled or disabled
    const errors = validate();
    const hasErrors = Object.keys(errors).length > 0;
    setIsSaveEnabled(!hasErrors);
  };

  useEffect(() => {
    if (selectedRow) {
      setEditedRow(selectedRow);
    }
  }, [selectedRow]);

  const tableRef = useRef(null);

  const exportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const tableNode = tableRef.current;

    // Get table data as an array of arrays
    const table2 = data4.map((row) => [
      row.id,
      row.material_type,
      row.material_category,
      row.material_code,
      row.short_text,
      row.long_text,
      row?.quantity,
      row?.unit,
      row?.dobs,
      row?.manufacturer,
      row?.manufacturer_model,
      row?.WBSElement,
      row?.plant,
      // { content: row?.stock?.map((item) => item.location).join("\n") },
      // { content: row?.stock?.map((item) => item.quantity).join("\n") },
    ]);

    const colsObj = columns2
      .filter((col) => col?.name !== "Quick Actions")
      .map((col) =>
        col?.name?.props?.children[2] ? col?.name?.props?.children[2] : col.name
      );
    const head = [colsObj];
    const didParseCell = function (data) {
      if (data.row.raw[0] === "Quick Actions") {
        data.cell.styles.visibility = "hidden";
      }
    };

    // Set options for autoTable
    const options = {
      head,
      body: table2,
      didParseCell,
    };

    doc.autoTable(options);

    // Save the PDF
    doc.save("table.pdf");
  };

  const printTable = () => {
    const printContents = document.querySelector(
      "#myTable .sc-dmctIk .sc-fLcnxK"
    ).outerHTML;

    // Create a new iframe element
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    // Write the printable content to the iframe
    const iframeDoc = iframe.contentWindow.document;
    const printDiv = document.createElement("div");
    printDiv.innerHTML = `
      <html>
        <head>
          <title>Print</title>
          <style>
            @media print {
              /* Add any additional print-specific styles here */
            }
          </style>
        </head>
        <body>${printContents}</body>
      </html>
    `;
    iframeDoc.body.appendChild(printDiv);

    // Call print() on the iframe's document
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Remove the iframe from the page
    document.body.removeChild(iframe);
  };

  // Custum pagination table 1 method
  const CustomPagination = ({ page, perPage, setPage, data }) => {
    const handlePrev = () => {
      if (page > 0) {
        setPage(page - 1);
      }
    };

    const handleNext = () => {
      if (page < Math.ceil(data.length / perPage) - 1) {
        setPage(page + 1);
      }
    };
    return (
      <div className="customPaginationMain">
        <div>
          Showing {page * perPage + 1} to{" "}
          {Math.min(data.length, (page + 1) * perPage)} of {data.length} entries
        </div>
        <div className="PaginationButtonMain">
          <button className="paginationButtons" onClick={handlePrev}>
            Previous
          </button>

          {Array.from({ length: Math.ceil(data.length / perPage) }, (_, i) => {
            if (
              Math.abs(i - page) <= 2 ||
              i === 0 ||
              i === Math.ceil(data.length / perPage) - 1
            ) {
              // Show the current page and the two adjacent pages, or the first and last pages
              return (
                <button
                  key={i}
                  onClick={() => setPage(i)}
                  className={i === page ? "activePage" : "paginationButtons"}
                >
                  {i + 1}
                </button>
              );
            } else if (Math.abs(i - page) === 3) {
              // Show an ellipsis and the last page number
              return <span key={i}>...</span>;
            } else {
              // Don't show this page number
              return null;
            }
          })}
          <button className="paginationButtons" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    );
  };

  // Custum pagination table 2 method
  const CustomPagination2 = ({
    page3,
    perPage3,
    setPage3,
    filteredData,
    handleChangeRowsPerPage,
  }) => {
    const handlePrev = () => {
      if (page3 > 0) {
        setPage3(page3 - 1);
      }
    };

    const handleNext = () => {
      if (page3 < Math.ceil(filteredData.length / perPage3) - 1) {
        setPage3(page3 + 1);
      }
    };

    // Calculate the start and end indices of the current page based on the full data array
    const startIndex = page3 * perPage3;
    const endIndex = Math.min(filteredData.length, (page3 + 1) * perPage3);

    return (
      <div className="customPaginationMain">
        <div>
          Showing {startIndex + 1} to {endIndex} of {filteredData.length}{" "}
          entries
        </div>
        <div className="PaginationButtonMain">
          <button className="paginationButtons" onClick={handlePrev}>
            Previous
          </button>
          {Array.from(
            { length: Math.ceil(filteredData.length / perPage3) },
            (_, i) => {
              if (
                Math.abs(i - page3) <= 2 ||
                i === 0 ||
                i === Math.ceil(filteredData.length / perPage3) - 1
              ) {
                // Show the current page and the two adjacent pages, or the first and last pages
                return (
                  <button
                    key={i}
                    onClick={() => setPage3(i)}
                    className={i === page3 ? "activePage" : "paginationButtons"}
                  >
                    {i + 1}
                  </button>
                );
              } else if (Math.abs(i - page3) === 3) {
                // Show an ellipsis and the last page number
                return <span key={i}>...</span>;
              } else {
                // Don't show this page number
                return null;
              }
            }
          )}
          <button className="paginationButtons" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    );
  };
  const location = useLocation();

  useEffect(() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();

    const currentDate = dd + "-" + mm + "-" + yyyy;
    setCurrntDate(currentDate);
    const myBooleanValue = location.state?.myBooleanValue;
    setBolean(myBooleanValue);
    const dataProps = location.state?.data;

    if (myBooleanValue == 1) {
      setSelectedOption(dataProps.Project);
    }
  }, []);

  function handleCloseModal() {
    setSelectedFiles([]);
    setShowModal(false);
  }

  const createNewImr = () => {
    setShowTable(false);
    setShowTableTwo(false);
    setSaveImr(false);
    setReleaseImr(false);
    setCreatePr(false);
    setInputValue("");
    setSelectedOption("");
    // setFilteredData([])
    setImrNo("");
    setStatus("");
    setdata4([]);
    setSelectedImageArray("");
    setPosts("");
    setProjectId("");
    setDobs("");
    setNames("");
    setEmails("");
    setRequiredDeliveryDate([]);
    setMaterialId("");
    setSelectedFiles([null]);
    setFile("");
    setFileInputs([{ id: 0, file: null }]);
  };

  function handleRemoveInput(id) {
    setFileInputs(fileInputs.filter((input) => input.id !== id));
    setSelectedImageArray(
      selectedImageArray.filter((image) => image.id !== id)
    );
  }

  function handleAddInput() {
    setDeleteFile(true);
    setFileInputs([...fileInputs, { id: fileInputs.length, file: null }]);
  }

  //upload image funtion
  const handleFileInputChange = (event, id) => {
    const file = event.target.files[0];
    const fileSizeInMB = file.size / (1024 * 1024); // convert bytes to MB
    if (fileSizeInMB > 1) {
      notify("The file size has exceeded the limit of 1MB", "error");
      return; // stop further processing
    }

    const newFileInputs = fileInputs.map((fileInput) => {
      if (fileInput.id === id) {
        const file = event.target.files[0];
        return {
          id,
          file,
          preview: URL.createObjectURL(file),
          fileName: file.name, // store the file name
        };
      }
      return fileInput;
    });
    setFileInputs(newFileInputs);

    const files = newFileInputs.map((fileInput) => {
      return { id: fileInput.id, file: fileInput.file };
    }); // extract the file property
    setSelectedImageArray(files);
  };

  //upload image funtion
  // const handleFileInputChange2 = (event, id, index) => {
  //   const newFileInputs = fileInputs.map((fileInput) => {
  //     if (fileInput.id === id) {
  //       const file = event.target.files[0];
  //       setFile(file.name);

  //       setSelectedFiles(file);

  //       return {
  //         id,
  //         file,
  //         preview: URL.createObjectURL(file),
  //         fileName: file.name, // store the file name
  //       };
  //     }
  //     return fileInput;
  //   });

  //   setFileInputs(newFileInputs);
  //   const files = newFileInputs.map((fileInput) => {
  //     return { id: fileInput.id, file: fileInput.file };
  //   }); // extract the file property
  //   // const fileObjects = files.map((file) => ({ file })); // create an array of file objects

  //   setSelectedImageArray(files);
  // };

  const handleFileInputChange2 = (event, id, index) => {
    const file = event.target.files[0];
    const fileSizeInMB = file.size / (1024 * 1024); // convert bytes to MB
    if (fileSizeInMB > 1) {
      notify("The file size has exceeded the limit of 1MB", "error");
      return; // stop further processing
    }

    const newFileInputs = fileInputs.map((fileInput) => {
      if (fileInput.id === id) {
        setFile(file.name);
        setSelectedFiles(file);

        return {
          id,
          file,
          preview: URL.createObjectURL(file),
          fileName: file.name, // store the file name
        };
      }
      return fileInput;
    });

    setFileInputs(newFileInputs);
    const files = newFileInputs.map((fileInput) => {
      return { id: fileInput.id, file: fileInput.file };
    }); // extract the file property

    setSelectedImageArray(files);
  };
  const authModal = secureLocalStorage.getItem("authModal");
  if (authModal) {
    return <UnAuthModal />;
  }
  //clear text when click on del button
  const handleClearInput = () => {
    setInputValue("");
    // setdata4([]);
    // setShowTable(false);
    // setIsOpen(false);

    inputRef.current.focus();
  };

  // toggle Method for add and remove rows in table two
  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };
  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setLevel(option.no_of_approval_level);
    setProjectId(option.id);
    setShowOptions(false);
    setPosts("");
    setUserFirstName("");
    setUserLastName("");
    setUserComment("");
    setShowTable(false);
    setFilterCountries([]);
    setFilterCountries2([]);
    setShowTableTwo(false);
    setSaveImr(false);
    setReleaseImr(false);
    setCreatePr(false);
    setInputValue("");
    // setFilteredData([])
    setStatus("");
    setImrNo("");
    setdata4([]);
    setSelectedImageArray("");
    setPosts("");
    setDobs("");
    setNames("");
    setEmails("");
    setRequiredDeliveryDate([]);
    setMaterialId("");
    setSelectedFiles([null]);
    setFile("");
    setProjectSearch("");
    setfilterProjects(projects.projects);
    setFileInputs([{ id: 0, file: null }]);
  };

  // styles
  const dropdownStyle = {
    position: "absolute",
    top: "60px",
    width: "80",
    background: "#fff",
    border: "1px solid #ddd",
    // maxHeight: "400px",
    // overflowY: "auto",
    zIndex: "9999",
  };
  // const getTimeImr = () => {
  //   let date = new Date();
  //   let hour = date.getHours();
  //   let minutes = date.getMinutes();

  //   let createdDate = `${hour}:${minutes}`;
  //   return createdDate;
  // };
  return (
    <div className="imrScreenMain">
      <Header showAlert={saveImr} data4={data4} />
      <ToastContainer />
      {loading && (
        <div className="loaderScreen">
          <Puff
            height={80}
            width={80}
            color="rgba(0, 120, 207, 1)"
            ariaLabel="puff-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      <div className="headerPosition">
        {/* header section 1 */}
        <div className="inner-image">
          <div className="ps-4 pe-4">
            <div className="headerStatus">
              {imrNumber ? (
                <div className="headerImageText1">
                  <p>IMR no:</p>
                  <p>{imrNumber}</p>
                </div>
              ) : (
                <div className="headerImageText4">
                  <p>IMR Date:</p>
                  <p> {CurrentData}</p>
                </div>
              )}

              {!status ? (
                <div className="headerImageInitial">
                  <p>initial</p>
                </div>
              ) : status == "saved" ? (
                <div className="headerImageSaved">
                  <p>Saved</p>
                </div>
              ) : releaseImr == "Pending" ? (
                <div className="headerImagePending">
                  <p>Pending</p>
                </div>
              ) : createPr == "Approved" ? (
                <div className="headerImageApproved">
                  <p>Approved</p>
                </div>
              ) : createPr == "Return" ? (
                <div className="headerImageApproved">
                  <p>Return</p>
                </div>
              ) : null}
            </div>
            {saveImr ? (
              <div className="d-flex">
                <div className="headerImageText">
                  <p>IMR Date:</p>
                  <p>{imrDate}</p>
                </div>
              </div>
            ) : (
              ""
            )}

            {/* {saveImr ? ( */}
            <div>
              <div className="headerImageText3">
                <p>Created By:</p>
                <p>
                  {firstName} {lastName}
                </p>
              </div>
            </div>
            {/* // ) : null} */}
          </div>
          <div className="SearchOnImage">
            <div className="SearchOnImage">
              <div className="onImage-Text">
                <h1>
                  Create an<strong> IMR Request</strong>
                </h1>
                {/* <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                  <br />
                  Lorem Ipsum has been the industry's standard dummy text{" "}
                </p> */}
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="app">
                <div className="custom-select" ref={dropdownRef}>
                  <div
                    className={
                      selectedOption ? "selected-option2" : "selected-option"
                    }
                    onClick={toggleOptions}
                  >
                    {selectedOption ? (
                      <div className="option w-100">
                        <div className="d-flex">
                          {projects?.projects?.map((option) =>
                            option.id === selectedOption.id ? (
                              <img
                                key={option.project_id}
                                src={starFill}
                                alt="starFill"
                              />
                            ) : null
                          )}
                          <span
                            className="ms-2"
                            style={{
                              overflow: "hidden",
                              fontSize: "19px",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                              maxWidth: "200px",
                            }}
                          >
                            {selectedOption.project_name}
                          </span>
                        </div>

                        <div>
                          <i
                            className={`fas fa-solid ${
                              showOptions ? "fa-caret-up" : "fa-caret-down"
                            }`}
                          ></i>
                        </div>
                      </div>
                    ) : (
                      <div className="option w-100">
                        <span>Select Project</span>
                        <i
                          className={`fas fa-solid ${
                            showOptions ? "fa-caret-up" : "fa-caret-down"
                          }`}
                        ></i>
                      </div>
                    )}
                  </div>
                  {showOptions && (
                    <div>
                      <div className="options">
                        <h1>All Projects</h1>
                        <div className="position-relative ms-4 me-4">
                          <input
                            type="text"
                            style={{ paddingLeft: "35px" }}
                            className=" dropdown-input-search-imr mb-3 w-100 "
                            placeholder="search project"
                            value={projectSearch}
                            onChange={handlerun}
                          />
                          <BsSearch
                            className="position-absolute start-0 ps-1"
                            style={{ marginLeft: "30px", marginTop: "-46px" }}
                            fontSize={"20px"}
                          />
                        </div>
                        <table>
                          <>
                            {filterProjects?.length > 0 ? (
                              <thead>
                                <tr className="HeaderDropDown">
                                  <th>Name</th>
                                  <th className="id">ID</th>
                                </tr>
                              </thead>
                            ) : (
                              ""
                            )}
                            <tbody className="customtab">
                              {filterProjects?.length > 0 ? (
                                filterProjects?.map((option, index) =>
                                  option.status == "1" ? (
                                    <tr
                                      key={index}
                                      onClick={() => handleOptionSelect(option)}
                                    >
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <i
                                            style={{
                                              position: "relative",
                                              right: "38px",
                                            }}
                                            className={`fa-solid ${
                                              selectedOption ===
                                              option.project_name
                                                ? "fa-check"
                                                : ""
                                            }`}
                                          ></i>
                                          <div className="d-flex align-items-center">
                                            <img src={star} alt="star" />
                                            <div className="ps-2">
                                              {option.project_name}
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="optionId">
                                        {option.project_id}
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )
                                )
                              ) : (
                                <p className="text-center mx-2 ">
                                  No Projects Found{" "}
                                </p>
                              )}
                            </tbody>
                          </>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <div className="headerSerachDropDown">
                  <span className="searchIcon">
                    <img width={25} src={Search} alt="search" />
                  </span>
                  {projectId ? (
                    <input
                      type="text"
                      placeholder="Search"
                      value={inputValue}
                      onChange={handleInputChange}
                      className="headerSearchInput"
                      ref={inputRef}
                    />
                  ) : (
                    <input
                      type="text"
                      placeholder="Search"
                      value={inputValue}
                      // onChange={handleInputChange}
                      className="headerSearchInputDisabled"
                      ref={inputRef}
                      disabled
                    />
                  )}

                  {inputValue !== "" && (
                    <span
                      className="crossSearchIcon"
                      onClick={handleClearInput}
                    >
                      <img src={close} alt="close" />
                    </span>
                  )}
                  {isOpen && inputValue !== "" && (
                    <div
                      ref={dropdownRef2}
                      style={{
                        ...dropdownStyle,
                        width: inputRef.current.offsetWidth,
                        width: "85%",
                      }}
                    >
                      <div className="SearchFilterImrIsr">
                        <img
                          src={filter2}
                          alt="filter2"
                          onClick={handleIconClick}
                        />
                        {isOpen2 && (
                          <div ref={dropdownRef} className="dropdown2">
                            <p
                              className={
                                selectedOptions2.includes(
                                  "Material Description"
                                )
                                  ? "selected2"
                                  : ""
                              }
                              onClick={() =>
                                handleOptionClick("Material Description")
                              }
                            >
                              Material Description
                            </p>
                            <p
                              className={
                                selectedOptions2.includes("Category")
                                  ? "selected2"
                                  : ""
                              }
                              onClick={() => handleOptionClick("Category")}
                            >
                              Material Category
                            </p>
                            <p
                              className={
                                selectedOptions2.includes("Material")
                                  ? "selected2"
                                  : ""
                              }
                              onClick={() => handleOptionClick("Material")}
                            >
                              Material Code
                            </p>
                          </div>
                        )}
                        {!isOpen2 && (
                          <div className="selectedOption2">{selectedIcons}</div>
                        )}
                      </div>

                      <table style={{ width: "100%" }}>
                        <thead className="ImrTable">
                          <tr>
                            <th>Material Description</th>
                            <th>Material Category</th>
                            <th>Material Code</th>
                          </tr>
                        </thead>
                        <tbody className="tBodyImr">
                          {FilterMethod().length === 0 ? (
                            <tr>
                              <td colSpan="3">No Result Found</td>
                            </tr>
                          ) : (
                            FilterMethod().map((item) => (
                              <tr
                                key={item.id}
                                onClick={() => handleDropdownClick(item)}
                              >
                                <td>{item.long_text}</td>
                                <td>{item.material_category}</td>
                                <td>{item.material_code}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main-content section 2*/}
      <div className="IsrMain">
        {/* table one  */}
        {!projectId && (
          <div class="container">
            <p
              style={{ color: "#0078cf", fontSize: 18 }}
              class="text-center mt-5"
            >
              Please select the project and search material to continue
            </p>
          </div>
        )}

        {showTable ? (
          <div className="container mb-4 tableIMr">
            <div className="imr-list-table">
              <div className="container">
                <div className="row TableRowImr align-items-center">
                  <div className="searchresultHeader mb-0 col-md-6 ">
                    <h1>Search Results</h1>
                  </div>

                  <div className="col-md-6">
                    <div className="custonDropdownIsr">
                      <div className="col-auto">
                        <div className="dropdown-center">
                          <i
                            className="imr-filter-btn d-inine-block"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-boundary="window"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-bs-auto-close="outside"
                          >
                            <img
                              src={filterSvg}
                              className="imr-filter-img"
                              height={17}
                              width={26}
                            />
                            <span className="name-filter">Filter</span>
                          </i>

                          <ul
                            className="dropdown-menu filterDropdown"
                            aria-labelledby="dropdownMenuLink"
                          >
                            <li>
                              <div
                                className="accordion accordion-flush"
                                id="accordionFlushExample"
                              >
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingOne"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseOne"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseOne"
                                    >
                                      Material Code
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseOne"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingOne"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${
                                          isOpen ? "is-open" : ""
                                        }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {filterCountries
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.material_code &&
                                                      t.material_code ===
                                                        item.material_code
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className="accordionlistItem"
                                                  key={item.material_code}
                                                  onClick={() =>
                                                    handleMaterialCodeAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.material_code}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingTwo"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseTwo"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseTwo"
                                    >
                                      Class
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingTwo"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${
                                          isOpen ? "is-open" : ""
                                        }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {filterCountries
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.class &&
                                                      t.class === item.class
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className="accordionlistItem"
                                                  key={item.class}
                                                  onClick={() =>
                                                    handleClassAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.class}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingThree"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseThree"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseThree"
                                    >
                                      Short Text
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingThree"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${
                                          isOpen3 ? "is-open" : ""
                                        }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {filterCountries
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.short_text &&
                                                      t.short_text ===
                                                        item.short_text
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className={`accordionlistItem ${
                                                    selectedOption3 ===
                                                    item.short_text
                                                      ? "selected"
                                                      : ""
                                                  }`}
                                                  key={item.class}
                                                  onClick={() =>
                                                    handleShortTextAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.short_text}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-auto">
                        <div className="searchresultHeader-imr">
                          Search:
                          <input
                            type="text"
                            onChange={(e) => setSearch(e.target.value)}
                            className="SearchResult"
                          />
                        </div>
                      </div>
                      <div className="col-auto">
                        {createPr ? (
                          <button
                            onClick={() => createNewImr()}
                            className="saveISR-btn"
                          >
                            Create New IMR
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="datatable-imr">
              <div className="datatable-imr">
                {filterCountries.length > 0 && (
                  <div>
                    <DataTable
                      sortIcon={
                        <div className="sort-icon">
                          {customSortIcon(sortDirection)}
                        </div>
                      }
                      onSort={handleSort}
                      sortColumn={sortColumn}
                      sortDirection={sortDirection}
                      striped
                      responsive
                      columns={columns}
                      data={filterCountries
                        .filter(
                          (item) =>
                            (!selectedMaterialCode ||
                              item.material_code ===
                                selectedMaterialCode.material_code) &&
                            (!selectedClass ||
                              item.class === selectedClass.class) &&
                            (!selectedShortText ||
                              item.short_text === selectedShortText.short_text)
                        )
                        .slice(page * perPage, (page + 1) * perPage)}
                      pagination
                      fixedHeader
                      fixedHeaderScrollHeight="450px"
                      selectableRowsHighlight
                      highlightOnHover
                      value={search}
                      paginationComponent={() => (
                        // custumPagination table 1
                        <CustomPagination
                          page={page}
                          perPage={perPage}
                          setPage={setPage}
                          data={filterCountries.filter(
                            (item) =>
                              (!selectedMaterialCode ||
                                item.service_code ===
                                  selectedMaterialCode.service_code) &&
                              (!selectedClass ||
                                item.UOM === selectedClass.UOM) &&
                              (!selectedShortText ||
                                item.short_text ===
                                  selectedShortText.short_text)
                          )}
                        />
                      )}
                      paginationPerPage={perPage}
                      paginationResetDefaultPage={true}
                      paginationPage={page}
                      onChangePage={(p) => {}}
                      onChangeRowsPerPage={(pp) => setPerPage(pp)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {/* table two  */}
        {data4.length > 0 && (
          <>
            <div className="mt-5 mb-5 ms-4 me-4 tableTwoImr">
              <h1 className="">Selected Materials</h1>
              <div className="searchresultHeader2">
                <div>
                  <div className="rowsPerPage">
                    show
                    <select
                      className="showperPage"
                      value={perPage3}
                      onChange={handleChangeRowsPerPage}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                    </select>
                    entries
                  </div>
                </div>
                <div className="selected-materialMain">
                  <ReactToPrint
                    trigger={() => (
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                      >
                        <img src={printImr} alt="print" />
                      </button>
                    )}
                    content={() => componentRef.current}
                  />
                  <img
                    className="editImageIcon my-element"
                    data-tooltip-content="Download Request"
                    style={{ width: 30 }}
                    src={pdfImr}
                    onClick={() => exportPDF()}
                    alt="pdf"
                  />
                  <button onClick={() => openModal()} className="deleteISR-btn">
                    Delete
                  </button>
                </div>

                {modalIsOpen ? (
                  <div className="deleteAccountMain">
                    <Modal
                      isOpen={modalIsOpen}
                      onAfterOpen={afterOpenModal}
                      onRequestClose={closeModal}
                      style={customStyles}
                      contentLabel="Example Modal"
                    >
                      <div className="delModelHeader">
                        <h2>Delete Confirmation</h2>
                        <div class="horizontal-line"></div>
                        <p>
                          Are you sure you want to delete
                          {selectedRows.length > 1
                            ? ` these ${selectedRows.length} `
                            : " this "}
                          {selectedRows.length > 1 ? "materials" : "material"}?
                        </p>
                        <div className="modal-button">
                          <button
                            onClick={() => handleDelete2()}
                            className="delAccountOkButton d-flex align-items-center justify-content-center"
                          >
                            Ok
                          </button>
                          <button
                            onClick={closeModal}
                            className="delAccountCancelButton d-flex align-items-center justify-content-center"
                          >
                            cancel
                          </button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="large-table" id="myTable">
                <div ref={componentRef}>
                  <DataTable
                    sortIcon={
                      <div className="sort-icon">
                        {customSortIcon(sortDirection)}
                      </div>
                    }
                    onSort={handleSort}
                    sortColumn={sortColumn}
                    sortDirection={sortDirection}
                    striped
                    responsive
                    columns={columns2}
                    // data={data4}
                    data={data4?.slice(
                      page3 * perPage3,
                      (page3 + 1) * perPage3
                    )}
                    pagination
                    paginationPerPage={perPage3}
                    paginationRowsPerPageOptions={[5, 10, 25]}
                    paginationComponent={() => (
                      // custumPagination table 2
                      <CustomPagination2
                        page3={page3}
                        perPage3={perPage3}
                        setPage3={setPage3}
                        filteredData={data4}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    )}
                    fixedHeader
                    selectableRowsHighlight
                    selectableRows={true}
                    onSelectedRowsChange={({ selectedRows }) =>
                      setSelectedRows(selectedRows)
                    }
                    highlightOnHover
                    ref={tableRef}
                  />
                </div>
              </div>
              {data4.length > 0 && (
                <div>
                  <div className="ISRBottom-section">
                    <div className="iSRUpload-main">
                      <div className="d-flex justify-content-between headerStatus">
                        <div>
                          <div className="uploadandPriviewMain">
                            <input
                              type="text"
                              placeholder="Choose File"
                              disabled
                              className="iSR-UploadInput"
                              value={file}
                            />
                            {!releaseImr && !createPr ? (
                              <label
                                htmlFor="file-input-0"
                                className="file-input-label"
                              >
                                <input
                                  ref={inputRefImage}
                                  id="file-input-0"
                                  type="file"
                                  accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,image/bmp,image/png,image/jpg,image/jpeg"
                                  onChange={(e) => handleFileInputChange2(e, 0)}
                                  style={{ display: "none" }}
                                />
                                upload
                              </label>
                            ) : (
                              <label
                                htmlFor="file-input-0"
                                className="file-input-labelDisable"
                              >
                                <input
                                  id="file-input-0"
                                  disabled
                                  type="file"
                                  accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,image/bmp,image/png,image/jpg,image/jpeg"
                                  onChange={(e) => handleFileInputChange2(e, 0)}
                                  style={{ display: "none" }}
                                />
                                upload
                              </label>
                            )}

                            <div className="priviewButton">
                              {!releaseImr && !createPr ? (
                                <div>
                                  {!deleteFile ? (
                                    <img
                                      onClick={() => handleRemove()}
                                      src={del}
                                      style={{ padding: 10 }}
                                      className="my-element"
                                      data-tooltip-content="Delete File"
                                    />
                                  ) : fileInputs.length == 1 ? (
                                    <img
                                      onClick={() => handleRemove()}
                                      src={del}
                                      style={{ padding: 10 }}
                                      className="my-element"
                                      data-tooltip-content="Delete File"
                                    />
                                  ) : (
                                    <img
                                      src={delDisable}
                                      style={{ padding: 10 }}
                                    />
                                  )}
                                </div>
                              ) : (
                                <div>
                                  <img
                                    src={delDisable}
                                    style={{ padding: 10 }}
                                  />
                                </div>
                              )}

                              <div>
                                <img
                                  onClick={() =>
                                    handlePreviewClick(fileInputs[0].file)
                                  }
                                  src={eye}
                                  style={{ padding: 10 }}
                                  className="my-element"
                                  data-tooltip-content="Preview File"
                                />
                              </div>
                              {fileInputs.some((input) => !input.file) ? (
                                <div>
                                  <img
                                    src={addDisable}
                                    style={{ padding: 10 }}
                                  />
                                </div>
                              ) : !releaseImr && !createPr ? (
                                <div>
                                  <img
                                    onClick={handleAddInput}
                                    src={add}
                                    style={{ padding: 10 }}
                                    className="my-element"
                                    data-tooltip-content="Add More File"
                                  />
                                </div>
                              ) : (
                                <div>
                                  <img
                                    src={addDisable}
                                    style={{ padding: 10 }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          {fileInputs.file && (
                            <div>
                              <img
                                src={fileInputs.preview}
                                alt={`Preview of ${fileInputs.fileName}`}
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />

                              <span>{fileInputs.fileName}</span>
                              <button
                                className="remove-button"
                                onClick={() => handleRemoveInput(fileInputs.id)}
                              >
                                Remove
                              </button>
                            </div>
                          )}
                          {fileInputs.slice(1).map((fileInput, index) => (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                marginTop: "10px",
                              }}
                              key={fileInput.id}
                            >
                              <input
                                type="text"
                                placeholder="Choose File"
                                disabled
                                className="iSR-UploadInput"
                                value={fileInput.fileName}
                              />

                              {!releaseImr && !createPr ? (
                                <label className="file-input-label">
                                  <input
                                    type="file"
                                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,image/bmp,image/png,image/jpg,image/jpeg"
                                    onChange={(e) =>
                                      handleFileInputChange(e, fileInput.id)
                                    }
                                  />
                                  upload
                                </label>
                              ) : (
                                <label
                                  htmlFor="file-input-0"
                                  className="file-input-labelDisable"
                                >
                                  <input
                                    id="file-input-0"
                                    disabled
                                    type="file"
                                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,image/bmp,image/png,image/jpg,image/jpeg"
                                    onChange={(e) =>
                                      handleFileInputChange2(e, 0)
                                    }
                                    style={{ display: "none" }}
                                  />
                                  upload
                                </label>
                              )}

                              {!releaseImr && !createPr ? (
                                <div>
                                  <img
                                    onClick={() =>
                                      handleRemoveInput(fileInput.id)
                                    }
                                    className=" my-element"
                                    data-tooltip-content="Delete File"
                                    src={del}
                                    style={{ padding: 10 }}
                                  />
                                </div>
                              ) : (
                                <div>
                                  <img
                                    src={delDisable}
                                    style={{ padding: 10 }}
                                  />
                                </div>
                              )}

                              <div>
                                <img
                                  onClick={() =>
                                    handlePreviewClick(fileInput.file)
                                  }
                                  className=" my-element"
                                  data-tooltip-content="Preview File"
                                  src={eye}
                                  style={{ padding: 0 }}
                                />
                              </div>

                              <div></div>
                            </div>
                          ))}

                          <Modal
                            isOpen={showModal}
                            onRequestClose={handleCloseModal}
                            style={{
                              content: {
                                width: selectedImageArray.length ? "800px" : "", // Set the desired width
                                height: selectedImageArray.length
                                  ? "560px"
                                  : "", // Set the desired height
                                margin: selectedImageArray.length ? "auto" : "", // Center the modal horizontally
                              },
                            }}
                          >
                            <div
                              style={{ cursor: "pointer", float: "right" }}
                              onClick={handleCloseModal}
                            >
                              {/* {alert(selectedFiles)} */}

                              <i class="fas fa-times fs-5"></i>
                            </div>
                            {selectedFiles &&
                            selectedFiles.length > 0 &&
                            selectedFiles[0] ? (
                              <div style={{ float: "left", width: "100%" }}>
                                {selectedFiles[0].type.split("/")[0] ===
                                "image" ? (
                                  <div>
                                    <img
                                      src={URL.createObjectURL(
                                        selectedFiles[0]
                                      )}
                                      style={{
                                        width: "100%",
                                        height: "480px",
                                        objectFit: "contain",
                                        marginTop: "10px",
                                      }}
                                    />
                                  </div>
                                ) : selectedFiles[0].type.split("/")[0] ===
                                    "application" &&
                                  selectedFiles[0].type ===
                                    "application/pdf" ? (
                                  <iframe
                                    src={URL.createObjectURL(selectedFiles[0])}
                                    style={{
                                      width: "100%",
                                      height: "450px",
                                      objectFit: "contain",
                                      marginTop: "10px",
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      position: "absolute",
                                      left: "35%",
                                      right: 0,
                                      top: "45%",
                                      bottom: 0,
                                    }}
                                  >
                                    <a
                                      href={URL.createObjectURL(
                                        selectedFiles[0]
                                      )}
                                      download={selectedFiles[0].name}
                                      className="btn btn-primary downloadButton"
                                    >
                                      <i class="fas fa-download"></i>
                                      {""} {selectedFiles[0].name}
                                    </a>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="noImage ">
                                <div>
                                  <img
                                    style={{ width: "300px" }}
                                    src={noImage}
                                    alt="noImage"
                                  />
                                </div>
                                <div>
                                  <p>No image found</p>
                                </div>
                              </div>
                            )}
                          </Modal>
                        </div>
                        <div className="custom-file"></div>
                      </div>
                      <div className="mt-2">
                        <p>. Accepted File: doc, pdf, xlsx, ppt, bmp, png</p>
                        <p>. File Size doesn’t exceed 1MB</p>
                      </div>
                    </div>
                    <div className="bottomTextIsr">
                      {/* <div>
                        <h6>Released By:<span> Suleman Ahmad</span></h6>
                      </div> */}
                      <div>
                        {imrDate ? (
                          <div>
                            <h6>
                              Released on:<span>{imrDate}</span>
                            </h6>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {!releaseImr && !createPr ? (
                    <div class="mb-3" className="isISRCommentMain">
                      <div className="iSRCommentBox">
                        <label
                          for="exampleFormControlTextarea1"
                          class="form-label"
                        >
                          <div className="tableHeaders">
                            <span
                              className="commentsSpan"
                              style={{ color: "red" }}
                            >
                              *
                            </span>{" "}
                            Comment
                          </div>
                        </label>
                        <p className="text-muted text-right ">
                          {textAreaValue.length}/1000
                        </p>
                      </div>
                      <div className="form-group">
                        <textarea
                          onChange={handlePost}
                          className="form-control"
                          aria-setsize={20}
                          rows="4"
                          maxLength="1000"
                          onInput={handleInput}
                          value={textAreaValue}
                        ></textarea>
                      </div>
                    </div>
                  ) : (
                    <div class="mb-3" className="isISRCommentMain">
                      <div className="iSRCommentBox">
                        <label
                          for="exampleFormControlTextarea1 commentDiable"
                          class="form-label"
                        >
                          Comment
                        </label>
                        <p className="text-muted text-right countDisable">
                          {textAreaValue.length}/1000
                        </p>
                      </div>
                      <div className="form-group">
                        <textarea
                          disabled
                          className="form-control"
                          aria-setsize={20}
                          rows="4"
                          maxLength="1000"
                          onInput={handleInput}
                          value={posts}
                        ></textarea>
                      </div>
                    </div>
                  )}
                  <div className="iSRBtnMain">
                    {!releaseImr && !createPr ? (
                      <button
                        disabled={!isSaveEnabled}
                        onClick={() =>
                          imrNumber ? EditableTableData() : saveImrMethod()
                        }
                        className="buttonSave"
                      >
                        Save
                      </button>
                    ) : (
                      <button className="saveDisableISR-btn">Save</button>
                    )}
                    {ReleaseButtonMethod(level)}

                    {releaseImr && releaseArray.length == level ? (
                      <button
                        onClick={() => navigate("/createimr")}
                        className="createPrISR-btn"
                      >
                        Create PR
                      </button>
                    ) : (
                      <button disabled className="createPrDisabledISR-btn">
                        Create PR
                      </button>
                    )}
                  </div>

                  {userComment ? (
                    <div className="commentsMain">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div>
                          <h2>{"All Comments"}</h2>
                          <div className="usersComments">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <h3>
                                {userFirstName} {userLastName}
                              </h3>
                              {/* <h4>
                                {imrDate} <br /> {imrTime}
                              </h4> */}
                            </div>
                            <div
                              style={{
                                alignItems: "center",
                                wordWrap: "break-word",
                                lineHeight: 1.3,
                              }}
                            >
                              <p
                                style={{
                                  marginRight: "10px",
                                  marginBottom: "0",
                                }}
                              >
                                {showFullText
                                  ? userComment
                                  : `${userComment.slice(0, 100)}`}
                              </p>
                              {userComment.length > 20 && (
                                <div onClick={handleReadMoreClick}>
                                  <h5>
                                    {" "}
                                    {showFullText ? "Read Less" : "Read More"}
                                  </h5>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 1 }}></div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <Tooltip anchorSelect=".my-element" type="dark" effect="solid" />

      <Footer />
    </div>
  );
};

export default Imr;
